import Textarea from './Textarea.vue';

export default Textarea;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/form/components/textarea/index.ts